import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { ILegacyCartEntry } from '@rbi-ctg/menu';
import useAddToCartRecentItem from 'hooks/use-add-to-cart-recent-item';
import { CustomEventNames } from 'state/amplitude';

import { AddIconButton } from './styled';

interface AddToCartProps {
  disabled: boolean;
  cartEntry: ILegacyCartEntry;
  amplitudeEvent?: CustomEventNames;
}

const AddToCart: React.FC<React.PropsWithChildren<AddToCartProps>> = ({
  disabled,
  cartEntry,
  amplitudeEvent,
}) => {
  const { formatMessage } = useIntl();
  const { addToCart, SwitchCartMethodDialog } = useAddToCartRecentItem({
    cartEntry,
    amplitudeEvent,
  });

  return (
    <>
      <AddIconButton
        variant="outline"
        onPress={addToCart}
        icon={<Icon variant={'add'} />}
        disabled={disabled}
        testID="add-to-cart"
        accessibilityLabel={formatMessage({ id: 'addToCart' })}
      />
      <SwitchCartMethodDialog />
    </>
  );
};

export default AddToCart;
